import React, { useCallback, useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import {
  withStyles,
  Theme,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";
import { Colors } from "../../utils/colors";
import Loading from "../../commonComponents/loading";
import SimpleBreadcrumbs from "../../commonComponents/breadCrumbs";
import { rolesArray, routePathNames } from "../../utils/constants";
import PaginationComponent from "../../commonComponents/pagination";
import Grid, { GridSpacing } from "@material-ui/core/Grid";
import { UserTableColumn, UserTableData } from "./types/users";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import "./css/users.css";
import { getUsers, deleteUser } from "./redux/actions/getUsers";
import { connect, useSelector } from "react-redux";
import ShowSnackBar from "../../commonComponents/snackBar";
import EmptyComponent from "../../commonComponents/emptyComponent";
import ManageButton from "../../commonComponents/manageButtons";

// @ts-ignore
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";

const columns: UserTableColumn[] = [
  { label: "Name", minWidth: 170 },
  { label: "Email", minWidth: 170 },
  {
    label: "Role(s)",
    minWidth: 100,
  },
  {
    label: "Manage",
    minWidth: 100,
  },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 420,
  },
});

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: Colors.brightBlue,
      color: Colors.white,
      fontWeight: "bold",
    },
    body: {
      fontSize: 18,
    },
  })
)(TableCell);

const Users = (props: any) => {
  const classes = useStyles();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [loading, setLoading] = React.useState(false);
  const [totalPage, setTotalPage] = React.useState(1);
  const [data, setData] = React.useState([]);
  const [snackBarVisisble, setSnackBarVisisble] = React.useState(false);
  const [snackBarMessage, setSnackBarMessage] = React.useState("");
  const breadData = [{ title: "Users", link: routePathNames.USERS }];

  const fetchUsersData = () => {
    setLoading(true);
    props
      .getUsers(currentPage)
      .then((result: any) => {
        console.log("resultresult", result);
        setData(result.data.user);
        setTotalPage(result.data.pageCount);
        setLoading(false);
      })
      .catch((err: any) => {
        setLoading(false);
        setData([]);
      });
  };

  const pageChangeHandlerCallback = (newPage: number) => {
    console.log("pageChangeHandlerCallback ~ newPage", newPage);
    setCurrentPage(newPage);
  };

  useEffect(() => {
    fetchUsersData();
  }, [currentPage]);

  const deleteUser = (item: any) => {
    let title = "Delete";
    let message = "Do you want to delete" + " " + item.name + " User" + "?";
    alertify.confirm(
      title,
      message,
      function () {
        deleteUserApiCall(item);
      },
      function () {
        // alertify.error('Cancel');
      }
    );
  };

  const deleteUserApiCall = (item: any) => {
    setLoading(true);
    props
      .deleteUser(item.id)
      .then((result: any) => {
        console.log("deleteUserApiCall", result);
        setLoading(false);
        if (result && result.isSuccess) {
          toggleSnackBar(true, result.data.message);
          if (data && data.length === 1) {
            console.log("data", data);
            setCurrentPage(currentPage - 1);
          } else {
            fetchUsersData();
          }
        } else {
          toggleSnackBar(true, result.message);
        }
      })
      .catch((err: any) => {
        setLoading(false);
      });
  };

  const editUser = (item: any) => {
    props.history.push({
      pathname: routePathNames.EDIT_USER,
      state: {
        data: item,
      },
    });
  };

  const toggleSnackBar = (isVisible = false, message = "") => {
    setSnackBarVisisble(isVisible);
    setSnackBarMessage(message);
  };

  return (
    <React.Fragment>
      <SimpleBreadcrumbs breadcrumbData={breadData} heading={"Users List"} />
      {data && data.length ? (
        <React.Fragment>
          <Paper className={classes.root}>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <StyledTableCell
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((item: UserTableData) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={item.id}
                      >
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.email}</TableCell>
                        <TableCell>{item.role.join(", ")}</TableCell>
                        <TableCell>
                          <span
                            className="icons-spacing cursor-pointer"
                            onClick={() => editUser(item)}
                          >
                            <ManageButton
                              title={"Edit User"}
                              buttonType={"edit"}
                            />
                          </span>
                          <span
                            className="cursor-pointer"
                            onClick={() => deleteUser(item)}
                          >
                            <ManageButton
                              title={"Delete User"}
                              buttonType={"delete"}
                            />
                          </span>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <Grid container justify="center">
            <PaginationComponent
              currentPage={currentPage}
              totalPage={totalPage}
              setPageCallback={pageChangeHandlerCallback}
            />
          </Grid>
        </React.Fragment>
      ) : !loading ? (
        <EmptyComponent />
      ) : null}
      <Loading isFetching={loading} />
      <ShowSnackBar
        isVisible={snackBarVisisble}
        message={snackBarMessage}
        handleClose={() => toggleSnackBar()}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    usersSuccessFailure: state.getUsers.usersSuccessFailure,
    deleteUserSuccessFailure: state.getUsers.deleteUserSuccessFailure,
  };
};

const mapDispatch = {
  getUsers: (pageNo: any) => getUsers(pageNo),
  deleteUser: (userId: any) => deleteUser(userId),
};

const connector = connect(mapStateToProps, mapDispatch);
export default connector(Users);
